import Notification from "../../../components/Common/Notification/index";
import * as shirtApi from "../../../services/shirt";
import {
  ADD_SHIRT_FAILURE,
  ADD_SHIRT_REQUEST,
  ADD_SHIRT_SUCCESS,
  DELETE_SHIRT_FAILURE,
  DELETE_SHIRT_REQUEST,
  DELETE_SHIRT_SUCCESS,
  GET_SHIRTS_FAILURE,
  GET_SHIRTS_REQUEST,
  GET_SHIRTS_SUCCESS,
  GET_SINGLE_SHIRT_FAILURE,
  GET_SINGLE_SHIRT_REQUEST,
  GET_SINGLE_SHIRT_SUCCESS,
  UPDATE_SHIRT_FAILURE,
  UPDATE_SHIRT_REQUEST,
  UPDATE_SHIRT_SUCCESS,
} from "./shirt.actionType";

export const requestAddShirt = () => {
  return {
    type: ADD_SHIRT_REQUEST,
  };
};

export const addShirtSuccess = (data) => {
  return {
    type: ADD_SHIRT_SUCCESS,
    data,
  };
};

export const addShirtFailure = (message) => {
  return {
    type: ADD_SHIRT_FAILURE,
    message,
  };
};

export const addShirt = (data) => {
  return (dispatch) => {
    dispatch(requestAddShirt());
    return shirtApi
      .addShirt(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addShirtSuccess(data));
        return data
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addShirtFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetShirts = () => {
  return {
    type: GET_SHIRTS_REQUEST,
  };
};

export const getShirtsSuccess = (data) => {
  return {
    type: GET_SHIRTS_SUCCESS,
    data,
  };
};

export const getShirtsFailure = (message) => {
  return {
    type: GET_SHIRTS_FAILURE,
    message,
  };
};

export const getShirts = () => {
  return (dispatch) => {
    dispatch(requestGetShirts());
    return shirtApi
      .getShirts()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getShirtsSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getShirtsFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSingleShirt = () => {
  return {
    type: GET_SINGLE_SHIRT_REQUEST,
  };
};

export const getSingleShirtSuccess = (data) => {
  return {
    type: GET_SINGLE_SHIRT_SUCCESS,
    data,
  };
};

export const getSingleShirtFailure = (message) => {
  return {
    type: GET_SINGLE_SHIRT_FAILURE,
    message,
  };
};

export const getSingleShirt = (id) => {
  return (dispatch) => {
    dispatch(requestgetSingleShirt());
    return shirtApi
      .getSingleShirt(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSingleShirtSuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSingleShirtFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeleteShirt = () => {
  return {
    type: DELETE_SHIRT_REQUEST,
  };
};

export const deleteShirtSuccess = (data) => {
  return {
    type: DELETE_SHIRT_SUCCESS,
    data,
  };
};

export const deleteShirtFailure = (message) => {
  return {
    type: DELETE_SHIRT_FAILURE,
    message,
  };
};

export const deleteShirt = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteShirt());
    return shirtApi
      .deleteShirt(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deleteShirtSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deleteShirtFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdateShirt = () => {
  return {
    type: UPDATE_SHIRT_REQUEST,
  };
};

export const updateShirtSuccess = (data) => {
  return {
    type: UPDATE_SHIRT_SUCCESS,
    data,
  };
};

export const updateShirtFailure = (message) => {
  return {
    type: UPDATE_SHIRT_FAILURE,
    message,
  };
};

export const updateShirt = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdateShirt());
    return shirtApi
      .updateShirt(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updateShirtSuccess(data));
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updateShirtFailure());
        Notification("", errorMessage, "error");
      });
  };
};
